import locale from "localization/en";

export const columns = [
  { key: "priceBuildUpId", text: locale.priceBuildUpId },
  { key: "stationCode", text: locale.stationCode, width: "120px" },
  { key: "customerName", text: locale.customerName, width: "200px" },
  { key: "stationName", text: locale.stationName, width: "180px" },
  { key: "stationType", text: locale.stationType, width: "100px" },
  { key: "island", text: locale.island, width: "100px" },
  { key: "area", text: locale.area, width: "150px" },
  { key: "effectiveDateTime", text: locale.effectiveDateAndTime, width: "160px" },
  { key: "status", text: locale.status, width: "110px" },
  { key: "processedBy", text: locale.processedByCreatedOn, width: "180px" },
  { key: "type", text: locale.priceType, width: "160px" },
  { key: "actions", text: locale.action, width: "80px" },
];
